module.exports = "/images/Family  Entertainment  Center.svg?6f30581487a135f60659558a8dd96ba7";